import React from 'react';
import { Image } from '@gasbuddy/react-components';
import classnames from 'classnames/bind';
import legendItems from '../../constants/legend-items';
import createMarkerIcon from '../../utils/createMarkerIcon';
import styles from './Legend.module.css';

const cx = classnames.bind(styles);

export default function Legend() {
  return (
    <div className={cx('legend')}>
      {legendItems.map(({ color, label }) => (
        <div key={color} className={cx('legendItem')}>
          <Image
            className={cx('legendItemIcon')}
            src={createMarkerIcon(color)}
            alt="Marker icon"
          />
          {label}
        </div>
      ))}
    </div>
  );
}
